import React, { useState } from 'react';
import { useAuth } from '../../contexts/FirebaseAuthContext';
import Logo from '../../components/ui/Logo';
import FloatingInput from '../../components/ui/FloatingInput';

const ForgotPassword: React.FC = () => {
  const { resetPassword } = useAuth();
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await resetPassword(email);
      setSent(true);
    } catch (err) {
      setError('Failed to send password reset email. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center bg-[#fdfbf5] font-[\'Plus Jakarta Sans\']">
      <div className="mt-8 mb-4">
        <Logo />
      </div>
      <div className="w-full max-w-[620px] mx-4 sm:mx-auto rounded-[28px] shadow-[0_4px_32px_0_rgba(0,0,0,0.08)] bg-white p-8 sm:p-8 xs:p-4 flex flex-col items-center font-[\'Plus Jakarta Sans\']" style={{ marginBottom: '40px' }}>
        <h2 className="text-3xl font-bold text-gray-900 mb-2 w-full text-left">Forgot Password</h2>
        <p className="text-gray-700 mb-6 w-full text-left text-base">Enter your email address and we'll send you a link to reset your password.</p>
        {sent ? (
          <div className="text-green-600 text-base mb-8 w-full max-w-[570px]">Password reset email sent! Please check your inbox.</div>
        ) : (
          <form className="w-full flex flex-col items-center" onSubmit={handleSubmit}>
            {error && <div className="text-red-600 text-sm mb-8 w-full max-w-[570px]">{error}</div>}
            <FloatingInput
              id="email"
              name="email"
              type="email"
              value={email}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)}
              placeholder="Your email"
              autoComplete="email"
            />
            <button
              type="submit"
              disabled={loading}
              className="w-full max-w-[570px] py-3 rounded-full bg-[#333333] text-white font-semibold text-base shadow-sm hover:bg-gray-800 transition disabled:opacity-60 font-[\'Plus Jakarta Sans\']"
              style={{ fontFamily: 'Plus Jakarta Sans, sans-serif', backgroundColor: '#333333' }}
            >
              {loading ? 'Sending...' : 'Send reset link'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword; 